import ChatPanel from "./chat-panel";
import NavPanel from "./navigation/nav-panel";
import { useNavigationStore } from "./../../store/navigationStore";
import useMdBreakpoint from "../../hooks/useMdBreakpoint";
import { useAppStore } from "./../../store/appStore";
import { CHAT_TYPE } from "@/types/navigation-mode";

interface BottomPanelProps {
  className?: string;
}

export default function BottomPanel({ className = "" }: BottomPanelProps) {
  const startAutoPlayDelay = useNavigationStore(
    (state) => state.startAutoPlayDelay
  );
  const stopAutoPlay = useNavigationStore((state) => state.stopAutoPlay);
  const isChatOpen = useAppStore((state) => state.isChatOpen);
  const setIsChatOpen = useAppStore((state) => state.setIsChatOpen);
  const isMd = useMdBreakpoint();

  const mobileBottomPanel = () => {
    return (
      isChatOpen && (
        <div className="mx-auto w-[calc(100%-40px)] mb-[20px]">
          <ChatPanel
            onChatClose={() => {
              setIsChatOpen(false);
              startAutoPlayDelay(2000);
            }}
            chatType={CHAT_TYPE.NAVIGATION}
          />
        </div>
      )
    );
  };

  const desktopChatPanel = () => {
    return (
      <div className="">
        {isChatOpen && (
          <>
            <div className="absolute right-0 bottom-0 w-[calc(100%-40px)] md:max-w-[353px] mb-[100px] mr-[20px] rounded-xl">
              <ChatPanel
                onChatClose={() => {
                  setIsChatOpen(false);
                  startAutoPlayDelay(2000);
                }}
                chatType={CHAT_TYPE.NAVIGATION}
              />
            </div>
          </>
        )}
      </div>
    );
  };

  const navigationPanel = () => {
    return (
      <NavPanel
        isChatActive={isChatOpen}
        onChatClick={() => {
          const newChatOpen = !isChatOpen;
          setIsChatOpen(newChatOpen);
          if (newChatOpen) {
            stopAutoPlay();
          } else {
            startAutoPlayDelay(2000);
          }
        }}
      />
    );
  };

  return (
    <>
      {isMd && desktopChatPanel()}
      {!isMd && (
        <div className={`bottom-panel ${className}`}>{mobileBottomPanel()}</div>
      )}
      {isMd || (!isMd && !isChatOpen) ? (
        <div className={`bottom-panel ${className}`}>{navigationPanel()}</div>
      ) : (
        <></>
      )}
    </>
  );
}
